export default __webpack_public_path__ + "static/media/saint-omermini.b7bca3e9.jpg";